import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { localize } from 'react-localize-redux';

import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';

import FooterButtons from 'components/shared/FooterButtons';
import { deepDiver } from 'helpers/utilities';

import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import AvailabilitiesForm from 'components/landlord_app/community/AvailabilitiesForm/AvailabilitiesForm';
import AmenityRestrictionsForm from 'components/landlord_app/community/AvailabilitiesForm/AmenityRestrictionsForm';
import ShowingRestrictionsForm from 'components/landlord_app/community/AvailabilitiesForm/ShowingRestrictionsForm';
import TabbedPanel from 'components/shared/TabbedPanel';
import AmenityForm from './AmenityForm';

import { drawerStyles } from 'helpers/StyleHelper';
import { getTranslatedString } from 'helpers/i18n';

const MOVE_OUT_INSPECTION = 5;
const PROPERTY_SHOWING = 6;

class AmenityDetailsOverview extends Component {
  state = {
    showConfirmationDialog: false,
  };

  updateAmenity = (formData) => {
    this.props.updateAmenity(formData);
  };

  toggleConfirmationDialog = () => {
    this.setState({
      showConfirmationDialog: !this.state.showConfirmationDialog,
    });
  };

  render() {
    const headerTranslation = (key) => {
      return getTranslatedString(`landlordPortal.amenities.tabHeader.${key}`);
    };
    let tabHeaders = null,
      tabBodies = null,
      tabFooters = null;
    if ([MOVE_OUT_INSPECTION].includes(deepDiver(this.props.amenity, 'amenity_type'))) {
      tabHeaders = [headerTranslation('availability')];
      tabBodies = [this.renderAvailabilityBody()];
      tabFooters = [this.renderCloseOnlyFooter()];
    } else if ([PROPERTY_SHOWING].includes(deepDiver(this.props.amenity, 'amenity_type'))) {
      tabHeaders = [headerTranslation('availability'), headerTranslation('restrictions')];
      tabBodies = [this.renderAvailabilityBody(), this.renderShowingRestrictionsBody()];
      tabFooters = [this.renderCloseOnlyFooter(), this.renderRestrictionsFooter()];
    } else {
      tabHeaders = [
        headerTranslation('details'),
        headerTranslation('availability'),
        headerTranslation('restrictions'),
      ];
      tabBodies = [
        this.renderDetailsBody(),
        this.renderAvailabilityBody(),
        this.renderRestrictionsBody(),
      ];
      tabFooters = [
        this.renderDetailsFooter(),
        this.renderCloseOnlyFooter(),
        this.renderRestrictionsFooter(),
      ];
    }

    return (
      <Fragment>
        <div className="row" style={drawerStyles.tabbedHeaderWrapper}>
          <h3 style={drawerStyles.tabbedHeader}>
            {(this.props.amenityFormData && this.props.amenityFormData.name) ||
              this.props.amenity.name}
          </h3>
        </div>

        <TabbedPanel tabHeaders={tabHeaders} tabBodies={tabBodies} tabFooters={tabFooters} />
      </Fragment>
    );
  }

  renderDetailsBody = () => {
    const { isUserAdmin, canAddAmenities } = this.props;
    const canEdit = canAddAmenities || isUserAdmin;
    return (
      <div style={drawerStyles.tabBodyWrapper}>
        <Card style={drawerStyles.card}>
          <AmenityForm
            disabled={!canEdit}
            onSubmit={this.updateAmenity}
            properties={this.props.properties}
            initialValues={this.props.amenity}
          />
        </Card>
        {canEdit && (
          <div style={{ textAlign: 'center', paddingBottom: '10px' }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.toggleConfirmationDialog}
              style={{ borderWidth: '2px' }}
            >
              {getTranslatedString('landlordPortal.amenities.form.delete')}
              <DeleteIcon style={{ fontSize: '21px', marginLeft: '8px' }} />
            </Button>
          </div>
        )}
        <ConfirmationDialog
          showDialog={this.state.showConfirmationDialog}
          hideDialog={this.toggleConfirmationDialog}
          userConfirmVerbiage={getTranslatedString('landlordPortal.amenities.form.delete')}
          userConfirmAction={this.props.deleteAmenity}
          dialogTitle={getTranslatedString('landlordPortal.amenities.form.are_you_sure')}
          dialogBodyVerbiage={getTranslatedString(
            'landlordPortal.amenities.form.are_you_sure_body'
          )}
        />
      </div>
    );
  };

  renderRestrictionsFooter = () => {
    return (
      <FooterButtons
        backName={getTranslatedString('landlordPortal.amenities.form.close')}
        backAction={this.props.toggleDrawer}
        formName="amenity_restrictions"
        submitName={getTranslatedString('landlordPortal.amenities.form.submit')}
      />
    );
  };

  renderDetailsFooter = () => {
    return (
      <FooterButtons
        backName={getTranslatedString('landlordPortal.amenities.form.close')}
        backAction={this.props.toggleDrawer}
        formName="add_amenity_form"
        submitName={getTranslatedString('landlordPortal.amenities.form.submit')}
      />
    );
  };

  renderAvailabilityBody = () => {
    if (!this.props.amenity) return null;

    return (
      <div style={drawerStyles.tabBodyWrapper}>
        <Card style={drawerStyles.card}>
          <AvailabilitiesForm
            weekData={this.props.availability.availabilities}
            submitAvailability={this.props.updateAvailability}
            disableTimePicking={['day', 'night'].includes(this.props.amenity.amenity_duration_type)}
          />
        </Card>
      </div>
    );
  };

  renderShowingRestrictionsBody = () => (
    <div style={drawerStyles.tabBodyWrapper}>
      <Card style={drawerStyles.card}>
        <ShowingRestrictionsForm
          formName="amenity_restrictions"
          onSubmit={this.updateAmenity}
          amenity={this.props.amenity}
          initialValues={this.props.amenity}
        />
      </Card>
    </div>
  );

  renderRestrictionsBody = () => {
    return (
      <div style={drawerStyles.tabBodyWrapper}>
        <Card style={drawerStyles.card}>
          <AmenityRestrictionsForm
            formName="amenity_restrictions"
            onSubmit={this.updateAmenity}
            amenity={this.props.amenity}
            initialValues={this.props.amenity}
          />
        </Card>
      </div>
    );
  };

  renderCloseOnlyFooter = () => {
    return (
      <FooterButtons
        hideSubmitButton
        backName={getTranslatedString('landlordPortal.amenities.form.close')}
        backAction={this.props.toggleDrawer}
      />
    );
  };
}

const ConnectedAmenityDetailsOverview = connect((store) => ({
  amenityFormData: deepDiver(store, 'form.add_amenity_form.values'),
  isUserAdmin: deepDiver(store, 'userTypes.admin'),
  canAddAmenities: deepDiver(store, 'userTypes.canAddAmenities'),
}))(AmenityDetailsOverview);

export default localize()(ConnectedAmenityDetailsOverview);
